import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { signOut } from 'next-auth/react';
import { GetServerSideProps } from 'next';

const SignOut = () => {
  const router = useRouter();

  useEffect(() => {
    signOut({ redirect: false }).then(() => {
      router.push('/');
    });
  }, []);

  return <div className="container">Signing out...</div>;
};

export const getServerSideProps: GetServerSideProps = async () => {
  return { props: { session: null } };
};

export default SignOut;
